<span class="trigger-wrapper">
    <ng-content select="[drawerTrigger]"></ng-content>
    <div *ngIf="triggerDirective?.templateRef" (click)="toggle()">
        <ng-container *ngTemplateOutlet="triggerDirective?.templateRef || null; context: context"></ng-container>
    </div>
</span>

<div class="drawer-wrapper mpro-box" [@openClose]="isOpen ? 'open' : 'closed'" (@openClose.done)="captureDoneEvent($event)">
    <div *ngIf="!hideCancel" class="drawer-cancel"><span (click)="toggle()">Cancel</span></div>
    <div class="drawer-content">
        <ng-content select="[drawerContent]"></ng-content>
    </div>
</div>

<ng-container *ngIf="isOpen">
    <div class="drawer-backdrop" [ngClass]="{'blur': !backdrop, 'half': !!backdrop}">
        <ng-container *ngTemplateOutlet="backdrop?.content || template"></ng-container>
    </div>
</ng-container>

<ng-template #template>
</ng-template>